import React, { useCallback, useState } from "react";
import { useDynamicForwardAction, DYNAMIC_FORWARD_BACKUP_NONE } from "../../hooks/useCallAction";
import DynamicForwardUI from "./DynamicForwardUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * DynamicForward component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const DynamicForward = ({
  setOpenConfigureSlotModal,
  route,
  setRoute,
  context = "root",
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const [localChannels] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.channels?.L || []
  );
  const recordings = routeModals?.recordings ?? localRecordings;
  const channels = routeModals?.channels ?? localChannels;
  const dynamicForwardLogic = useDynamicForwardAction(context, route, setRoute);

  const handleDestinationChange = useCallback(
    (value) => {
      if (value === DYNAMIC_FORWARD_BACKUP_NONE) {
        dynamicForwardLogic.handleNumberChange(DYNAMIC_FORWARD_BACKUP_NONE);
        return;
      }
      const [channelId, phoneFromModal] = Array.isArray(value) ? value : [value, undefined];
      const phone = phoneFromModal ?? (() => {
        const ch = channels?.find((c) => (c.M?.ch_id?.S ?? c.ch_id) === channelId);
        return ch ? (ch.M?.value?.S ?? ch.value) : channelId;
      })();
      dynamicForwardLogic.handleNumberChange(phone);
    },
    [channels, dynamicForwardLogic.handleNumberChange]
  );

  const addDestinationOption = routeModals
    ? { label: "Add Forwarding Number", onClick: () => routeModals.openAddChannelModal("forward_number", handleDestinationChange) }
    : undefined;
  const addRecordingOption = routeModals
    ? { label: "Add Recording", onClick: () => routeModals.openAddRecordingModal(dynamicForwardLogic.handleRecordingChange) }
    : undefined;

  return (
    <DynamicForwardUI
      {...dynamicForwardLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      channels={channels}
      recordings={recordings}
      hasValidationError={hasValidationError}
      addDestinationOption={addDestinationOption}
      addRecordingOption={addRecordingOption}
      onDestinationChange={handleDestinationChange}
    />
  );
};

export default DynamicForward;
